import { GetSchedulesInterface } from "@type/schedules.types"
import { calculateTimeDifferenceWrtDst, timeInHoursMinutesfromSeconds } from "config/utils"
import useFeatureFlags from "./useFeatureFlags"
import { FeatureFlagEnums } from "../types/featureFlags.type"

const useGetScheduleCurrentWeekHours = (schedules: GetSchedulesInterface[]) => {
	const { featureFlagEnabled } = useFeatureFlags()
	const respectDst = featureFlagEnabled(FeatureFlagEnums.RESPECT_DST)

	const totalAllocatedTime: number[] = []
	const totalUnAllocatedTime: number[] = []
	if (schedules.length) {
		schedules
			.filter(schedule => !schedule.deletedAt)
			.forEach(({ startTime = new Date().toISOString(), finishTime = new Date().toISOString(), employee }) => {
				employee
					? totalAllocatedTime.push(
							calculateTimeDifferenceWrtDst(startTime, finishTime, "seconds", respectDst),
					  )
					: totalUnAllocatedTime.push(
							calculateTimeDifferenceWrtDst(startTime, finishTime, "seconds", respectDst),
					  )
			})

		const showTotalAllocatedTime = timeInHoursMinutesfromSeconds(totalAllocatedTime)

		const showTotalUnAllocatedTime = timeInHoursMinutesfromSeconds(totalUnAllocatedTime)

		const showTotalTime = {
			totalTime: +Number(showTotalAllocatedTime.totalTime) + Number(showTotalUnAllocatedTime.totalTime),
		}

		return {
			showTotalTime,
			showTotalAllocatedTime,
			showTotalUnAllocatedTime,
		}
	} else {
		return {
			showTotalUnAllocatedTime: { totalTime: 0 },
			showTotalTime: { totalTime: 0 },
			showTotalAllocatedTime: { totalTime: 0 },
		}
	}
}

export default useGetScheduleCurrentWeekHours
